import { FormStateType } from "../../../../types";
import { INCIDENT_DETAILS_CONSTANTS } from "../../../constants";

export const formFieldsState: FormStateType = {
  [INCIDENT_DETAILS_CONSTANTS.INCIDENT_DATE]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [INCIDENT_DETAILS_CONSTANTS.DATE_OF_SUBMISSION]: {
    value: "",
    errors: [],
    hidden: true,
    ignoreInFinalForm: false,
    disabled: true,
  },
  [INCIDENT_DETAILS_CONSTANTS.TYPE_OF_CLAIM]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [INCIDENT_DETAILS_CONSTANTS.CLAIM_TYPE_DETAILS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [INCIDENT_DETAILS_CONSTANTS.CLAIM_TYPE_ID]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [INCIDENT_DETAILS_CONSTANTS.CLAIM_TYPE_DESCRIPTION]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [INCIDENT_DETAILS_CONSTANTS.TOTAL_CLAIM_CURRENCY_DETAILS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [INCIDENT_DETAILS_CONSTANTS.TOTAL_CLAIM_CURRENCY_CODE]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [INCIDENT_DETAILS_CONSTANTS.TOTAL_CLAIM_VALUE]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [INCIDENT_DETAILS_CONSTANTS.EXPECTED_ARRIVAL_DATE]: {
    value: "",
    errors: [],
    hidden: true,
  },
  [INCIDENT_DETAILS_CONSTANTS.LOCATION_OF_INCIDENT]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [INCIDENT_DETAILS_CONSTANTS.DETAILED_INCIDENT_SUMMARY]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [INCIDENT_DETAILS_CONSTANTS.POLICE_REPORT_AVAILABLE]: {
    value: "No Information",
    errors: [],
    hidden: false,
  },
  [INCIDENT_DETAILS_CONSTANTS.CARGO_OR_PROPERTY_LOCATION]: {
    value: "",
    errors: [],
    hidden: true,
  },
  [INCIDENT_DETAILS_CONSTANTS.CONTACT_DETAILS]: {
    value: "",
    errors: [],
    hidden: true,
  },
  [INCIDENT_DETAILS_CONSTANTS.CONTACT_NAME]: {
    value: "",
    errors: [],
    hidden: true,
  },
  [INCIDENT_DETAILS_CONSTANTS.CONTACT_PHONE_NUMBER]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [INCIDENT_DETAILS_CONSTANTS.CONTACT_EMAIL_ADDRESS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [INCIDENT_DETAILS_CONSTANTS.ADDITIONAL_INFORMATION]: {
    value: "",
    errors: [],
    hidden: false,
  },
};
